<template>
	<Header class="header"/>
	<RouterView :key="$route.fullPath" />
	<bottom/>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import Header from '@/components/header.vue';
import bottom from '@/components/bottom.vue';
</script>

<style lang="styl" scoped>
.header {
	position sticky;
	top 0
	width 100%
	background #fff
	z-index 2000
}
</style>
